import React, { useState } from 'react'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { Skeleton } from '@mui/material';
import CoordonneMap from '../Models/CoordonneMap';
import env from 'react-dotenv';

const containerStyle = {
    width: '100%',
    height: '400px'
};


function Map() {

    const center: CoordonneMap = { "lat" : 4.058620, "lng" : 9.711371};

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: env.GOOGLE_MAPS_API_KEY
    })
    const [activeMarker, setActiveMarker] = useState(null);

    const handleActiveMarker = (marker: any) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
    };

    const marker = {
        "numero" : 0,
        "lieu": "Douala",
        "emplacement" : "Makepe Missoke",
        "coordonnees" : { "lat" : 4.058620, "lng" : 9.711371},
        "region" : "Littoral",
        "telephone" : ["233 000 123"],
        "dateCreation" : "..."
    }

    const onLoad = React.useCallback(function callback(map: any) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        // const bounds = new window.google.maps.LatLngBounds(center);
        // map.fitBounds(bounds);
    }, [])

    const onUnmount = React.useCallback(function callback(map: any) {
    }, [])

    return isLoaded ? (
        <div style={{ border: "2px ##0cc0df solid", borderRadius: "1%", overflow: "auto" }}>
             
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={12}
                onLoad={onLoad}
                onUnmount={onUnmount}
            // options={ {maxZoom:12} }
            >
              
                <Marker
                    title={marker.lieu + " (" + marker.emplacement + ")"}
                    key={marker.numero}
                    position={marker.coordonnees}
                    onClick={() => handleActiveMarker(marker.numero)}
                >
                </Marker>
            </GoogleMap>
        </div>
    ) : <Skeleton variant='rounded' width={"100%"} height={400} />
}

export default Map